import React, { useRef } from "react";
import { BiMinus, BiPlus } from "react-icons/bi";
import { BiFoodMenu } from "react-icons/bi";
import { FaConciergeBell } from "react-icons/fa";
import { RiFileList2Line } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Logo from "../../Assets/Logo";
import Gap from "../../components/Gap";
import Loading from "../../components/Loading";
import Navbar from "../../components/Navbar";
import { getTabSetting } from "../../config/config.js";
import { imageBaseUrl, router, url } from "../../Constants.js";
import { Kategory as LayoutKategory } from "../../Layout";
import SubKategory from "../../Layout/SubKategoty";
import {
  getKategory,
  produkActions,
  setKeranjang,
  shiftActions,
} from "../../redux/actions/prepareActions";
import api from "../../request";
import { decrypt, encrypt } from "../../utils/enkripsi";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log.js";
import ModalBayar from "./ModalBayar";
import ModalPaket from "./ModalPaketPromo";
import "./Order.css";

export default function Order() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { addToast } = useToasts();
  const state = useSelector((state) => state?.dataPrepare);
  const [showBayar, setShowBayar] = React.useState(false);
  const [sidebar, setSidebar] = React.useState(false);
  const [dataProduct, setDataProduct] = React.useState([]);
  const [loadingScroll, setLoadingScroll] = React.useState(false);
  const [dataOrder, setDataOrder] = React.useState({});
  const [dataBranch, setDataBranch] = React.useState({});
  const [label_error, setlabel_Error] = React.useState({});
  const [showSubKategory, setShowKategory] = React.useState(false);
  const [showModalPaket, setShowModalPaket] = React.useState(false);
  const [style, setStyle] = React.useState({});
  const [order, setOrder] = React.useState({
    item: 0,
    total: 0,
  });
  const [dataMeja, setDataMeja] = React.useState([]);
  const produk = state?.data;
  const orderData = state?.order;
  let login = localStorage.getItem("login");
  let pesanan = localStorage.getItem("pesanan");
  pesanan = pesanan == null ? [] : decrypt(JSON.parse(pesanan));
  const isFetching = useRef(false);
  const [quantities, setQuantities] = React.useState({});
  const [note, setNote] = React.useState("");
  const [buttonStates, setButtonStates] = React.useState({
    minus: {},
    plus: {},
  });
  const [isInsideRadius, setIsInsideRadius] = React.useState(false);
  const hasShownTooFarToast = useRef(false);
  const errorToastShown = useRef(false);
  const [prevQuantities, setPrevQuantities] = React.useState({});

  const handleGoToMetodePembayaran = async () => {
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    if (!dataBranch?.detailData) {
      navigate(router + "/lacak-pesanan");
      return;
    }

    try {
      const result = await api.apiPrepare.getOrder({
        id: dataBranch.detailData,
      });
      const siId = result?.data?.[0]?.si_id || result?.data?.[0]?.id;
      if (siId) {
        navigate(`${router}/metode-pembayaran/${siId}`);
        return;
      }
    } catch (e) {
      // fall back below
    }

    navigate(router + "/lacak-pesanan");
  };

  const handleScroll = () => {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (
      windowBottom + 1 >= docHeight &&
      produk.total_baris > 10 &&
      !isFetching.current
    ) {
      isFetching.current = true;
      setLoadingScroll(true);
      dispatch(
        produkActions({
          ...produk,
          currentPage: produk.currentPage + 10,
          total_baris: produk.total_baris - 10,
        })
      );
    }
  };

  const geolocation = async () => {
    const tabSetting = await getTabSetting("pesan_table_qr_location");
    if (tabSetting.data[0].onoff != 0) {
      let maxRadius = tabSetting.data[0].value;
      let userLongitude = 0;
      let userLatitude = 0;
      let longitude = 0;
      let latitude = 0;
      const dataBranch = localStorage.getItem("dataBranch");
      if (dataBranch) {
        try {
          const parsedData = JSON.parse(dataBranch);
          longitude = parsedData.longitude || 0;
          latitude = parsedData.latitude || 0;
        } catch (e) {
          console.error("Error parsing dataBranch from localStorage:", e);
        }
      }
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            userLatitude = position.coords.latitude;
            userLongitude = position.coords.longitude;
            const within = isWithinRadius(
              longitude,
              latitude,
              userLongitude,
              userLatitude,
              maxRadius
            );
            setIsInsideRadius(within);
          },
          (error) => {
            if (!errorToastShown.current) {
              addToast("Error getting location: " + error.message, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 5000,
              });
              errorToastShown.current = true;
            }
          }
        );
      } else {
        if (!errorToastShown.current) {
          addToast("Geolocation is not supported by this browser.", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          errorToastShown.current = true;
        }
      }
    } else {
      setIsInsideRadius(true);
    }
  };

  React.useEffect(() => {
    showLog("Order Masuk useEffect 1");
    let saveCustomer = decrypt(
      JSON.parse(localStorage.getItem("saveCustomer"))
    );
    if (saveCustomer == null) {
      localStorage.setItem("saveCustomer", JSON.stringify(encrypt("false")));
    }
    let fromPaymentSuccess = decrypt(
      JSON.parse(localStorage.getItem("fromPaymentSuccess"))
    );
    if (fromPaymentSuccess == null) {
      localStorage.setItem(
        "fromPaymentSuccess",
        JSON.stringify(encrypt("false"))
      );
    }
    if (produk.data) {
      setDataProduct(produk.data);
    }
    isFetching.current = false;
    setLoadingScroll(false);
    document.addEventListener("scroll", handleScroll);
    if (orderData?.data[0]?.trans_status == 1) {
      addToast(
        "Transaksi pada 'MEJA " +
        orderData?.data[0].data[0]?.table_id +
        "' sudah selesai, harap untuk meminta QR kembali ke kasir!",
        {
          appearance: "info",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        }
      );
      navigate(router + "/bill");
    }
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [produk]);


  // async function loginUruzPro() {
  //   try {
  //     const login = await fetch('https://uruzpro.com/auth-services/token/', {
  //       method: 'POST',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //         'Cache-Control': 'no-cache',
  //         'Accept-Encoding': 'gzip;q=1.0, compress;q=0.5',
  //       },
  //       body: JSON.stringify({
  //         email: 'syahrul05011@gmail.com',
  //         password: '12345aA-',
  //       }),
  //     });

  //     const resultLogin = await login.json();

  //     if (resultLogin && resultLogin.token) {
  //       console.log('hasil response login uruzpro', resultLogin);
  //       localStorage.setItem("tokenUruzPro", resultLogin.token);
  //       return resultLogin;
  //     } else {
  //       console.log('gagal login uruzpro', resultLogin);
  //       return;
  //     }
  //   } catch (error) {
  //     console.log('Terjadi error:', error);
  //   }
  // }


  const prepareLogin = async () => {
    let checkStatus = false;
    const prepareLogin = JSON.parse(sessionStorage.getItem("prepareLogin"));
    const s = getUrlVars();
    const branchQueryString = await decrypt(s.params);
    console.log("INI ISI branchQueryString = ", branchQueryString)
    // localStorage.setItem("userServer", "server");
    const dataBranch = JSON.parse(localStorage.getItem("dataBranch"));
    // const userServer = JSON.parse(localStorage.getItem("userServer"));
    const userServer = localStorage.getItem("userServer");
    dispatch(shiftActions());
    let users = {};
    if (branchQueryString) {
      // localStorage.removeItem("pesanan");
      setDataMeja(branchQueryString);
      localStorage.setItem("type", branchQueryString.type);
      localStorage.setItem("meja", branchQueryString.meja);
      localStorage.setItem("serialNumber", branchQueryString.serialNumber);
      localStorage.setItem(
        "userServer",
        JSON.stringify(branchQueryString.clientID)
      );
      localStorage.setItem(
        "cashierName",
        JSON.stringify(encrypt(branchQueryString.cashier_name))
      );
      users.clientID = branchQueryString.clientID;
      users.branch_id = branchQueryString.branchID;
      const res = await api.apiPrepare.getPos({
        branches: [branchQueryString.branchID],
      });
      let items = res.data[0];
      let getCurrentLoginData = {};
      getCurrentLoginData.branchID = items.id;
      if (branchQueryString.detailDataID) {
        getCurrentLoginData.detailData = branchQueryString.detailDataID;
      }
      getCurrentLoginData.branchName = items.name;
      getCurrentLoginData.branchAddress = items.address;
      getCurrentLoginData.branchTel = items.mobile;
      getCurrentLoginData.picpath = items.picpath;
      localStorage.setItem(
        "dataBranch",
        JSON.stringify(Object.assign(getCurrentLoginData, items))
      );
      setDataBranch(Object.assign(getCurrentLoginData, items));
      const local_charges = await api.apiPrepare.getCharge();
      localStorage.setItem("localCharges", JSON.stringify(local_charges.data));
      if (branchQueryString.type == "tableQR") {
        users.detailData = branchQueryString.detailDataID;
      }
      localStorage.setItem(
        "userServer",
        JSON.stringify(branchQueryString.clientID)
      );
    } else {
      if (dataBranch) {
        const nomermeja = localStorage.getItem("meja");
        setDataMeja({
          meja: nomermeja,
          detailDataID: dataBranch.detailData,
        });
        users.clientID = userServer;
        users.branch_id = dataBranch.branchID;
        setDataBranch(dataBranch);
        if (dataBranch.detailData) {
          users.detailData = dataBranch.detailData;
        }
      } else {
        checkStatus = true;
      }
    }
    if (!login && !prepareLogin) {
      if (label_error.value == "") {
        setTimeout(() => {
          setSidebar(true);
          setStyle({
            width: "90%",
            top: "30%",
            position: "absolute",
            left: "5%",
          });
        }, 2000);
      }
    }
    if (checkStatus) {
      setlabel_Error({
        label: "Mohon Scan QR untuk melakukan transaksi",
        value: 2,
      });
      dispatch({
        type: "SET_GET_DATA_PRODUK",
        value: {
          data: [],
          loading: false,
        },
      });
      dispatch({
        type: "SET_GET_PAKET",
        value: {
          data: [],
          loading: false,
        },
      });
    } else {
      if (produk?.data?.length == 0) {
        updateOrder();
        dispatch(produkActions());
        dispatch(getKategory());
      }
    }
    geolocation();
  };

  React.useEffect(() => {
    showLog("Order Masuk useEffect 2");
    // loginUruzPro();
    prepareLogin();
  }, []);

  React.useEffect(() => {
    if (!showBayar) {
      showLog("Order Masuk useEffect 3");
      const updatedPesanan = JSON.parse(JSON.stringify(pesanan));
      const newQuantities = {};
      updatedPesanan.forEach((item) => {
        newQuantities[item.product_id] = item.item || 0;
      });
      setQuantities(newQuantities);
      setPrevQuantities(newQuantities);
    }
  }, [showBayar]);

  function getUrlVars() {
    showLog("Order Masuk getUrlVars");
    localStorage.setItem(
      "saveLinkOrder",
      JSON.stringify(encrypt(window.location.href))
    );
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  }

  function updateOrder() {
    showLog("Order Masuk updateOrder");
    let pesanan = decrypt(JSON.parse(localStorage.getItem("pesanan")));
    let items = 0;
    let total = 0;
    if (pesanan) {
      for (const xi of pesanan) {
        items += xi["item"];
        total += xi["total"];
        setOrder({
          item: items,
          total: total,
        });
      }
    }
  }

  function onOrder(items) {
    showLog("Order Masuk onOrder");
    setShowBayar(true);
    setDataOrder(items);
  }

  function onOrderPaket(items) {
    showLog("Order Masuk onOrderPaket");
    setShowModalPaket(true);
    setDataOrder(items);
  }

  function onClickTambahPesanan(changeType) {
    const message =
      changeType === "increase"
        ? "Pesanan berhasil ditambah"
        : "Pesanan berhasil dikurangi";
    addToast(message, {
      appearance: "success",
      autoDismiss: true,
      autoDismissTimeout: 1500,
    });
  }

  function imageExists(url, callback) {
    showLog("Order Masuk imageExists");
    var img = new Image();
    img.onload = function () {
      callback(true);
    };
    img.onerror = function () {
      callback(false);
    };
    img.src = url;
  }

  const handleTambahPesanan = (item, quantity, itemId) => {
    const finalQuantity = Math.max(quantity, 1);
    const updatedPesanan = JSON.parse(JSON.stringify(pesanan));
    const existingItemIndex = updatedPesanan.findIndex(
      (cartItem) => cartItem.product_id === item.product_id
    );
    let quantityChanged = prevQuantities[itemId] !== finalQuantity;
    if (existingItemIndex >= 0) {
      updatedPesanan[existingItemIndex].item = finalQuantity;
      updatedPesanan[existingItemIndex].total =
        updatedPesanan[existingItemIndex].usePrice * finalQuantity;
    } else {
      updatedPesanan.push({
        ...item,
        item: finalQuantity,
        total: item.usePrice * finalQuantity,
        note: note,
      });
      quantityChanged = true;
    }
    console.log("INI ISI updatedPesanan = ", updatedPesanan)
    console.log("INI ISI updatedPesanan.filter((i) => i.item > 0) = ", updatedPesanan.filter((i) => i.item > 0))
    localStorage.setItem(
      "pesanan",
      JSON.stringify(encrypt(updatedPesanan.filter((i) => i.item > 0)))
    );
    dispatch(setKeranjang(updatedPesanan.filter((i) => i.item > 0)));
    setQuantities((prev) => ({
      ...prev,
      [itemId]: finalQuantity,
    }));
    setPrevQuantities((prev) => ({
      ...prev,
      [itemId]: finalQuantity,
    }));
    setShowBayar(false);
    if (quantityChanged) {
      const changeType =
        finalQuantity > (prevQuantities[itemId] || 0) ? "increase" : "decrease";
      onClickTambahPesanan(changeType);
    }
  };

  if (pesanan.length !== 0) {
    for (const item of dataProduct) {
      for (const items of pesanan) {
        if (item["product_id"] == items["product_id"]) {
          item["item"] = items["item"];
        }
      }
    }
  } else {
    for (const item of dataProduct) {
      item["item"] = null;
    }
  }

  function isWithinRadius(restoLng, restoLat, userLng, userLat, maxRadius) {
    showLog("Order Masuk isWithinRadius");
    const toRadians = (angle) => angle * (Math.PI / 180);
    const φ1 = toRadians(restoLat);
    const φ2 = toRadians(userLat);
    const Δφ = toRadians(userLat - restoLat);
    const Δλ = toRadians(userLng - restoLng);
    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = 6371000 * c;
    if (distance > maxRadius && !hasShownTooFarToast.current) {
      addToast(
        "Lokasi Anda terlalu jauh dari restoran untuk melakukan pemesanan",
        {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        }
      );
      hasShownTooFarToast.current = true;
    }
    return distance <= maxRadius;
  }

  return (
    <div>
      <Navbar
        label_error={label_error}
        setStyle={setStyle}
        style={style}
        sidebar={sidebar}
        setSidebar={(val) => {
          if (!val && style.width) {
            sessionStorage.setItem("prepareLogin", JSON.stringify("1"));
          }
          setSidebar(val);
        }}
      />
      <ModalBayar
        updateOrder={updateOrder}
        dataOrder={dataOrder}
        showBayar={showBayar}
        setShowBayar={setShowBayar}
        onClickTambahPesanan={(changeType) => {
          onClickTambahPesanan(changeType);
        }}
      />
      <ModalPaket
        updateOrder={updateOrder}
        dataOrder={dataOrder}
        showModalPaket={showModalPaket}
        setShowModalPaket={setShowModalPaket}
        onClickTambahPesanan={() => {
          if (Number(order["item"]) == 0) {
            onClickTambahPesanan();
          }
        }}
      />
      <div>
        <div style={{ height: "100%", paddingTop: "17%" }}>
          {dataBranch?.picpath?.length > 3 && (
            <img
              style={{
                height: "auto",
                width: "100%",
                zIndex: "-1",
                position: "relative",
              }}
              src={imageBaseUrl + dataBranch.picpath}
            />
          )}
          {(!dataBranch?.picpath || dataBranch?.picpath?.length < 4) && (
            <div
              style={{
                height: "auto",
                width: "100%",
                zIndex: "-1",
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Logo />
            </div>
          )}
        </div>
        <div
          style={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            margin: isInsideRadius ? "-30px 20px 0px 20px" : "-100px 20px 0px",
            height: 200,
            backgroundColor: "#fff",
            borderRadius: 10,
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          }}
        >
          <div style={{ textAlign: "center", marginLeft: 10, marginRight: 10 }}>
            <div className="fonts700" style={{ fontSize: 16, paddingTop: 10 }}>
              {dataBranch.branchName}
            </div>
            <div
              className="fonts500"
              style={{ fontSize: 14, color: "#7E7E7E" }}
            >
              {dataBranch?.branchAddress || "-"}
            </div>
            <div className="fonts700" style={{ fontSize: 16, paddingTop: 10 }}>
              MEJA
            </div>
            <div
              className="fonts500"
              style={{ fontSize: 14, color: "#7E7E7E" }}
            >
              {dataMeja?.meja}
            </div>
            <div className="fonts700" style={{ fontSize: 16, paddingTop: 10 }}>
              ID
            </div>
            <div
              className="fonts500"
              style={{ fontSize: 14, color: "#7E7E7E", paddingBottom: 10 }}
            >
              {dataMeja?.detailDataID?.substring(0, 6) || "-"}
            </div>
          </div>
        </div>
        {isInsideRadius && (
          <>
            <div
              style={{
                position: "sticky",
                top: 60,
                zIndex: 100,
                backgroundColor: "white",
                margin: "20px 20px 0 20px",
                borderRadius: 10,
              }}
            >
              <LayoutKategory setShowSubKategory={setShowKategory} />
              {showSubKategory && (
                <SubKategory setShowModalPaket={setShowModalPaket} />
              )}
            </div>
            <div
              style={{
                height: produk.loading ? "600px" : "100%",
              }}
            >
              <div
                style={{
                  margin: "20px 20px 0 20px",
                  height: "100%",
                  backgroundColor: "#fff",
                  paddingBottom: Number(order["item"]) > 0 ? 50 : 50,
                  borderRadius: 10,
                }}
              >
                {dataProduct?.length !== 0 &&
                  dataProduct?.map((item, index) => {
                    const itemId = item.product_id || item.id || index;
                    const quantity = quantities[itemId] || 0;
                    const imageUrl = imageBaseUrl + item.picpath1;
                    return (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderRadius: 5,
                          margin: 10,
                          borderBottom: "1px solid #BFBFBF",
                        }}
                      >
                        <div
                          onClick={() => {
                            if (orderData?.data?.length !== 0) {
                              if (orderData?.data[0]["trans_status"] < 1) {
                                onOrder(item);
                              } else {
                                addToast(
                                  "ID sudah pernah digunakan, Mohon Scan QR terbaru untuk melakukan transaksi",
                                  {
                                    appearance: "success",
                                    autoDismiss: true,
                                  }
                                );
                              }
                            } else if (item.name != null) {
                              onOrderPaket(item);
                            } else {
                              onOrder(item);
                            }
                          }}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div style={{ position: "relative" }}>
                            {item.picpath1 && item.picpath1 !== "-" ? (
                              <img
                                style={{
                                  height: 100,
                                  width: 100,
                                  borderRadius: 5,
                                  marginBottom: 10,
                                  marginTop: 10,
                                  border: "1px #0000",
                                }}
                                src={
                                  item.base_url
                                    ? item.base_url + item.picpath1
                                    : url + item.picpath1
                                }
                                alt={
                                  item.product_name || item.name || "Product"
                                }
                              />
                            ) : (
                              <div
                                style={{
                                  height: 100,
                                  width: 100,
                                  borderRadius: 5,
                                  marginBottom: 10,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Logo />
                              </div>
                            )}
                            {item.item > 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: 14,
                                  right: 0,
                                  width: 20,
                                  backgroundColor: "#fff",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  borderTopLeftRadius: 5,
                                  borderBottomRightRadius: 5,
                                  border: "1px solid #BFBFBF",
                                }}
                              >
                                {item.item}
                              </div>
                            )}
                          </div>
                          <div style={{ margin: "0 10px 0 10px" }}>
                            <div className="fonts700">
                              {(item.product_name || item.name || "")
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase()
                                )
                                .join(" ")}
                            </div>
                            <span
                              className="fonts700"
                              style={{ marginRight: 10 }}
                            >
                              {"Rp" +
                                formatterMoney(item.usePrice || item.harga)}
                            </span>
                            <br />
                            <span
                              style={{
                                marginRight: 10,
                                fontSize: "13px",
                                textAlign: "justify",
                                display: "block",
                              }}
                            >
                              {item.description_menu}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div style={{ display: "flex" }}>
                            <div
                              style={{
                                display: "flex",
                                // width: "40%",
                                backgroundColor: "#fff",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <button
                                onClick={() => {
                                  if (quantity > 0) {
                                    const newQuantity = quantity - 1;
                                    setPrevQuantities((prev) => ({
                                      ...prev,
                                      [itemId]: quantity,
                                    }));
                                    setQuantities((prev) => ({
                                      ...prev,
                                      [itemId]: newQuantity,
                                    }));
                                    setButtonStates((prev) => ({
                                      ...prev,
                                      minus: { ...prev.minus, [itemId]: true },
                                    }));
                                    setTimeout(() => {
                                      setButtonStates((prev) => ({
                                        ...prev,
                                        minus: {
                                          ...prev.minus,
                                          [itemId]: false,
                                        },
                                      }));
                                    }, 200);
                                  }
                                }}
                                style={{
                                  border: `1px solid ${quantity > 0 ? "#5451D6" : "#BFBFBF"
                                    }`,
                                  height: 40,
                                  width: 40,
                                  borderRadius: 10,
                                  backgroundColor: buttonStates.minus[itemId]
                                    ? "#5451D6"
                                    : "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  transition:
                                    "background-color 0.2s ease-in-out",
                                }}
                              >
                                <BiMinus
                                  size={20}
                                  color={
                                    buttonStates.minus[itemId]
                                      ? "#fff"
                                      : quantity > 0
                                        ? "#5451D6"
                                        : "#BFBFBF"
                                  }
                                />
                              </button>
                              <span
                                className="fonts700"
                                style={{ fontSize: 20 }}
                              >
                                {quantity}
                              </span>
                              <button
                                onClick={() => {
                                  if (
                                    orderData?.data?.[0]?.trans_status < 1 ||
                                    orderData?.data.length == 0
                                  ) {
                                    const newQuantity = quantity + 1;
                                    setPrevQuantities((prev) => ({
                                      ...prev,
                                      [itemId]: quantity,
                                    }));
                                    setQuantities((prev) => ({
                                      ...prev,
                                      [itemId]: newQuantity,
                                    }));
                                    setButtonStates((prev) => ({
                                      ...prev,
                                      plus: { ...prev.plus, [itemId]: true },
                                    }));
                                    setTimeout(() => {
                                      setButtonStates((prev) => ({
                                        ...prev,
                                        plus: { ...prev.plus, [itemId]: false },
                                      }));
                                    }, 200);
                                  } else {
                                    addToast(
                                      "ID sudah pernah digunakan, Mohon Scan QR terbaru untuk melakukan transaksi",
                                      {
                                        appearance: "success",
                                        autoDismiss: true,
                                      }
                                    );
                                  }
                                }}
                                style={{
                                  border: "1px solid #5451D6",
                                  height: 40,
                                  width: 40,
                                  borderRadius: 10,
                                  backgroundColor: buttonStates.plus[itemId]
                                    ? "#5451D6"
                                    : "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  transition:
                                    "background-color 0.2s ease-in-out",
                                }}
                              >
                                <BiPlus
                                  size={20}
                                  color={
                                    buttonStates.plus[itemId]
                                      ? "#fff"
                                      : "#5451D6"
                                  }
                                />
                              </button>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <button
                              onClick={() =>
                                handleTambahPesanan(item, quantity, itemId)
                              }
                              disabled={quantity === 0}
                              style={{
                                padding: "10px 5px 10px 5px",
                                borderRadius: 5,
                                backgroundColor:
                                  quantity === 0 ? "#BFBFBF" : "#552CB7",
                                width: "80%",
                                marginRight: 10,
                                marginLeft: 10,
                                marginTop: 10,
                                display: "flex",
                                justifyContent: "space-around",
                                border: "none",
                                alignItems: "center",
                                cursor:
                                  quantity === 0 ? "not-allowed" : "pointer",
                                opacity: quantity === 0 ? 0.7 : 1,
                              }}
                            >
                              <div
                                style={{ color: "#fff" }}
                                className="fonts500"
                              >
                                Tambah
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                {<Gap height={10} />}
                {produk?.loading || (loadingScroll && <Loading />)}
              </div>
            </div>
            {!produk?.loading && dataProduct?.length == 0 && (
              <div
                style={{
                  margin: "20px 20px 0 20px",
                  height: 300,
                  paddingBottom: Number(order["item"]) > 0 ? 50 : 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  className="fonts700"
                  style={{
                    fontSize: 25,
                    color: "#5451D6",
                    textAlign: "center",
                  }}
                >
                  {label_error.label}
                </span>
              </div>
            )}
          </>
        )}
      </div>
      {isInsideRadius && (
        <>
          <div>
            <div className="jumlah-order">
              <div
                style={{
                  margin: 10,
                  width: "100%",
                  borderRadius: 5,
                  display: "flex",
                  justifyContent: "space-around",
                  border: "1px solid #5451D6",
                }}
              >
                <div
                  onClick={() => {
                    const dataBranch = JSON.parse(
                      localStorage.getItem("dataBranch")
                    );
                    if (dataBranch) {
                      navigate(`${router}/`);
                    }
                  }}
                  style={{
                    textDecoration: "none",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <BiFoodMenu size={20} color="#808080" />
                  <div style={{ fontSize: 10, color: "#808080" }}>Menu</div>
                </div>

                <div
                  onClick={() => {
                    const dataBranch = JSON.parse(
                      localStorage.getItem("dataBranch")
                    );
                    if (dataBranch) {
                      navigate(`${router}/call-waiters`);
                    }
                  }}
                  style={{
                    textDecoration: "none",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <FaConciergeBell size={20} color="#808080" />
                  <div style={{ fontSize: 10, color: "#808080" }}>
                    Panggil Pelayan
                  </div>
                </div>

                <div
                  onClick={() => {
                    const dataBranch = JSON.parse(
                      localStorage.getItem("dataBranch")
                    );
                    if (dataBranch) {
                      handleGoToMetodePembayaran();
                    }
                  }}
                  style={{
                    textDecoration: "none",
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  <RiFileList2Line size={20} color="#808080" />
                  <div style={{ fontSize: 10, color: "#808080" }}>Bill</div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
